import React from 'react';
import { Table } from '../../../components/table/Table';
import { useNavigation } from '@react-navigation/native';
import { TableHeader } from '../../../components/table/Headers';
import { AddButton } from '../../../components/button/AddButton';
import { useInvoke } from '../../../controllers/useInvoke';

export const BlogsTable = (props) => {
  const {route: {params}} = props;
  const {row} = params || {};
  const website = row?._id;

  const navigation = useNavigation();

  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'blog',
  });

  return (
    <Table
      eventSourceId={["blog"]}
      api={`/blogmodels`}
      fields={{
        keyword: 1,
        time: 1,
        title: 1,
        description: 1,
        is_published: 1,
      }}
      filter={{
        website,
      }}
      sort={{createdOn: -1}}
      renderHeader={() => (
        <TableHeader
          title="Blogs"
          actions={[
            <AddButton
              title="Add Blog"
              view="add-blog-unthinkable"
              params={{
                website,
              }}
            />,
          ]}
        />
      )}
      onRowPress={({ row }) => {
        navigation.navigate('edit-blog-unthinkable', { row, website });
      }}
      columns={[
        {
          type: 'text',
          field: 'keyword',
          header: 'Keyword',
        },
        {
          type: 'textArea',
          field: 'title',
          header: 'Title',
        },
        {
          type: 'textArea',
          field: 'description',
          header: 'Description',
        },
        {
          type: 'boolean ',
          field: 'is_published',
          header: 'Publish',
          align: 'center',
        },
        {
          header: 'Time to Read',
          field: 'time',
          type: 'text',
          align: 'center',
        },
      ]}
      moreActions={() => [
        {
          title: 'Edit',
          onPress: ({ row }) => {
            navigation.navigate('edit-blog-unthinkable', { row, website });
          },
        },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({ row }) => {
            deleteInvoke({
              uri: `/blogmodels/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
    />
  );
};
